import { render, staticRenderFns } from "./following.vue?vue&type=template&id=4b2345f3&scoped=true"
import script from "./following.vue?vue&type=script&lang=js"
export * from "./following.vue?vue&type=script&lang=js"
import style0 from "./following.vue?vue&type=style&index=0&id=4b2345f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2345f3",
  null
  
)

export default component.exports